// extracted by mini-css-extract-plugin
export default {"SpreadTabs":"Tuto_SpreadTabs__kyUPa","FullVideo":"Tuto_FullVideo__pi3BH","AbsoluteFullSize":"Tuto_AbsoluteFullSize__j08V1"};